export default __webpack_public_path__ + "static/media/graduated.91f025e2.png";